import React, { FC } from 'react';
import { Trash2 as Trash } from 'react-feather';
import { Box, Grid, Typography } from '@mui/material';
import { PvDialog } from './PvDialog';

/*
 * Types.
 */

interface DeleteEventConfirmModalProps {
  onConfirm: () => void;
  open: boolean;
  onClose: () => void;
}

/*
 * Component.
 */

export const DeleteEventConfirmModal: FC<DeleteEventConfirmModalProps> = ({
  onConfirm,
  open,
  onClose,
}: DeleteEventConfirmModalProps) => (
  <PvDialog
    onConfirm={onConfirm}
    title="Delete Event?"
    open={open}
    onClose={onClose}
    closeButtonText="No, Keep"
    confirmButtonText="Yes, Delete"
    titleIcon={<Trash color="#FE6257" />}
  >
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography>
            Are you sure you want to delete this event? This will remove the
            event and the contacts associated with it.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  </PvDialog>
);
